import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  CommunityGusDictionaryRequestBody,
  CommunityGusField,
  CommunityGusFieldFromApi,
} from './community-gus-dictionary.model';

@Injectable({
  providedIn: 'root',
})
export class CommunityGusDictionaryService {
  private dictionary: Record<string, Observable<CommunityGusField[]>> = {};
  constructor(private httpClient: HttpClient) {}

  get(
    body: CommunityGusDictionaryRequestBody,
  ): Observable<CommunityGusField[]> {
    const cacheKey = body.getCacheKey();
    if (!this.dictionary[cacheKey]) {
      this.dictionary[cacheKey] = this.httpClient
        .post<CommunityGusFieldFromApi[]>(`/api/emuia/gus/slo/gmina`, body)
        .pipe(
          map((data) =>
            data.map((fieldFromApi) =>
              CommunityGusField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary[cacheKey];
  }
}
